import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Báo cáo BOD (Ezy). Mã nghiệp vụ, tên bảng, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'bod.svc.c.type': 'Loại job',
  'bod.svc.c.cus': 'Khách',
  'bod.svc.c.pod': 'Cảng đến',
  'bod.svc.c.sub': 'Dịch vụ con',
  'bod.svc.c.portName': 'Tên cảng',
  'bod.svc.c.jobs': 'Job',
  'bod.svc.c.lines': 'Dòng dịch vụ',
  'bod.svc.c.share': 'Tỷ trọng',
  'bod.svc.c.open': 'Đang mở',
  'bod.svc.bar.cus': 'Xếp hạng khách theo số job',
  'bod.svc.bars.cus': 'top 12 · 90 ngày',
  'bod.svc.bar.pod': 'Xếp hạng tuyến theo số job',
  'bod.svc.bars.pod': 'cảng đến · 90 ngày',
  'bod.svc.bar.sub': 'Dòng dịch vụ con trong kỳ',
  'bod.svc.bars.sub': 'số dòng dịch vụ',
  'bod.svc.openN': 'mở {n}',
  'bod.svc.t.jobs': 'Job trong kỳ',
  'bod.svc.t.ob': 'Tỷ trọng OB',
  'bod.svc.t.rf': 'Hàng lạnh RF',
  'bod.svc.t.svcj': 'Job có dịch vụ phụ',
  'bod.svc.t.jobN': '{n} job',
  'bod.svc.group': 'Nhóm theo',
  'bod.svc.g.time': 'Thời gian',
  'bod.svct.k1': 'Job theo loại · 12 tháng',
  'bod.svct.s1': 'cột OB · LS · TR · đường = dòng vận tải TRF',
  'bod.svct.trf': 'TRF vận tải',
  'bod.svct.peak': 'đỉnh {n} job',
  'bod.svct.k2': 'Việc theo dịch vụ · 12 tháng',
  'bod.svct.s2': 'Job theo loại (OB · LS · TR) và dòng dịch vụ con (TRF vận tải · DOC chứng từ · CCF thông quan · SCY bãi · DDL giao nhận) theo tháng',
  'bod.svct.month': 'Tháng',
  'bod.svct.k3': 'Ma trận dịch vụ con × tháng',
  'bod.svct.s3': 'số dòng dịch vụ · ô đậm = tháng cao nhất của dịch vụ đó · cột cuối = quý gần nhất so quý trước',
  'bod.svct.total': 'Tổng',
  'bod.svct.sum': 'Tổng',
  'bod.svct.quarter': 'Quý',
  'bod.svct.ins2': 'ma trận dịch vụ con',
  'bod.svct.i1': 'Đỉnh {hi} ({hn} job), đáy {lo} ({ln} job — Tết).',
  'bod.svct.i2': '3 tháng gần nhất bình quân {r} job/tháng, {c} so 3 tháng trước',
  'bod.svct.i2b': ' — đang hồi phục sau đáy T9.',
  'bod.svct.i3': 'TRF (vận tải) {a} quý gần nhất, DOC (chứng từ) {b} — chứng từ giảm mạnh hơn số job, kiểm tra việc nhập dịch vụ DOC có bị sót.',
  'bod.svct.j1up': '{c} ({n}) tăng mạnh nhất quý gần nhất: {d}.',
  'bod.svct.j1dn': '{c} ({n}) giảm ít nhất — mọi dịch vụ đều giảm quý gần nhất: {d}.',
  'bod.svct.j2': '{c} ({n}) giảm mạnh nhất: {d} — xem có thiếu dòng dịch vụ hay mất khách.',
  'bod.svct.j3': 'Tháng nào cả cột nhạt (T2) là mùa thấp điểm chung; ô đậm lệch khỏi mùa là bất thường cần hỏi người phụ trách.',
  'bod.svc.g.type': 'Loại job',
  'bod.svc.g.cus': 'Khách',
  'bod.svc.g.pod': 'Tuyến',
  'bod.svc.g.sub': 'Dịch vụ con',
  'bod.svc.k.type': 'Theo loại job',
  'bod.svc.ins': 'Nhận định',
  'bod.svc.ins.sub': 'theo cơ cấu job',
  'bod.svc.k.cus': 'Theo khách · top 12',
  'bod.svc.k.pod': 'Theo tuyến · cảng đến',
  'bod.svc.k.sub': 'Theo dịch vụ con',
  'bod.svc.s.type': 'số job trong kỳ',
  'bod.svc.s.cus': '90 ngày gần nhất (1.346 job) · không đổi theo kỳ đang chọn',
  'bod.svc.s.pod': '90 ngày gần nhất · POL: VNSGN 1.076 · VNVUT 389 · VNHPH 89 · VNDNA 12',
  'bod.svc.s.sub': 'số dòng dịch vụ trong kỳ',
  'bod.dk.w1': 'Chờ BOD duyệt',
  'bod.dk.w1s': '1 vụ · [BOD-DIR] PHILIP',
  'bod.dk.w1i': 'KPE-2610-001 · Sai chứng từ → phí amend/manifest',
  'bod.dk.w2': 'Kiểm soát',
  'bod.dk.w2s': 'tự duyệt / kiêm nhiệm',
  'bod.dk.w2i': 'Báo cáo tự duyệt & kiêm nhiệm',
  'bod.dk.w2is': 'ở bàn BOD · Tổng quan',
  'bod.dk.w2l': 'Mở bàn BOD ›',
  'bod.dk.w3s': 'điểm theo vị trí · chốt kỳ',
  'bod.dk.w3i': 'Kỳ Oct/2026 đang mở',
  'bod.dk.w3is': 'chưa chốt',
  'bod.dk.w3l': 'Mở KPI ›',
  'bod.dk.n0': 'Ghi chú dữ liệu',
  'bod.dk.n0s': 'đọc trước khi so kỳ',
  'bod.dk.n1': 'Tháng 10 tính đến 22/Oct/2026',
  'bod.dk.n1s': 'job có JobDate tương lai vẫn được đếm',
  'bod.dk.n2': 'Khách / hãng là số khác nhau',
  'bod.dk.n2s': 'theo tháng · quý / năm hiện trung bình tháng',
  'bod.dk.n3': 'Top khách, tuyến: 90 ngày',
  'bod.dk.n3s': 'không đổi theo kỳ đang chọn',
  'bod.dk.n4': 'Dịch vụ con: số dòng',
  'bod.dk.n4s': 'một job có thể nhiều dòng dịch vụ',
  'bod.later': 'Chưa mở ở bản này',
  'bod.title': 'Báo cáo điều hành', 'bod.backLabel': 'Về Tổng quan',
  'bod.mode.m': 'Tháng', 'bod.mode.q': 'Quý', 'bod.mode.y': 'Năm',
  'bod.modeLabel': 'Loại kỳ', 'bod.prev': 'Kỳ trước', 'bod.next': 'Kỳ sau', 'bod.density': 'Mật độ hiển thị',
  'bod.dense.std': 'Chuẩn', 'bod.dense.cmp': 'Gọn',
  'bod.notif': 'Thông báo', 'bod.openRight': 'Mở cột phải', 'bod.export': 'Xuất báo cáo tháng',
  'bod.reports': 'Báo cáo', 'bod.tab.ov': 'Tổng quan', 'bod.tab.hr': 'Nhân sự', 'bod.tab.ops': 'Hoạt động KD', 'bod.tab.svc': 'Hiệu suất dịch vụ', 'bod.tab.sla': 'SLA mail & chat', 'bod.tab.fleet': 'Đội xe', 'bod.tab.evt': 'Sai sót & khen thưởng',
  'bod.vsPrev': ' so kỳ trước', 'bod.prevNone': 'kỳ trước: —', 'bod.prevNone2': 'kỳ trước —', 'bod.prevVal': '{d} · trước {v}',
  'bod.spark': '{k} 12 tháng {a}–{b}',
  'bod.avgSuffix': ' · TB/tháng',
  'bod.sec.metrics': 'Chỉ số',
  'bod.t.jobs': 'Job trong kỳ', 'bod.t.ob': 'OB · xuất', 'bod.t.ls': 'LS · logistics', 'bod.t.tr': 'TR · vận tải', 'bod.t.rf': 'Hàng lạnh RF',
  'bod.t.rfSub': '{p} tổng job', 'bod.t.cus': 'Khách có job', 'bod.t.cusSub': 'khách khác nhau', 'bod.t.car': 'Hãng tàu', 'bod.t.carSub': 'hãng khác nhau', 'bod.t.trf': 'Chuyến TRF',
  'bod.chart': 'Job theo tháng', 'bod.chartSub': 'theo JobDate', 'bod.peak': 'đỉnh 560 job',
  'bod.chartAria': 'Job theo tháng, chia OB / LS / TR / IB: {v}',
  'bod.open': 'Job chưa hoàn tất', 'bod.openSub': '120 ngày gần nhất',
  'bod.openAria': 'Job chưa hoàn tất theo nhóm: {v}', 'bod.openAria2': 'Job chưa hoàn tất theo ShipmentStatus',
  'bod.notFinish': 'chưa Finish',
  'bod.etd14': 'ETD trong 14 ngày tới', 'bod.cus90': 'Khách hoạt động 90 ngày',
  'bod.sub': 'Dịch vụ con', 'bod.subSub': 'số dòng theo JobDate', 'bod.thisP': 'Kỳ này', 'bod.prevP': 'Kỳ trước',
  'bod.subAria': 'Dịch vụ con: {v}', 'bod.opening': '{src} · đang mở {n}',
  'bod.s.trf': 'TRF · Vận tải (chuyến)', 'bod.s.doc': 'DOC · Chứng từ (C/O, kiểm dịch, hun trùng)', 'bod.s.ccf': 'CCF · Thông quan', 'bod.s.scy': 'SCY · Bãi / CY', 'bod.s.ddl': 'DDL · Giao nhận chứng từ', 'bod.s.svcj': 'Job có dịch vụ phụ',
  'bod.fin': 'Chứng từ tài chính', 'bod.finSub': 'số chứng từ trong kỳ · không kèm số tiền',
  'bod.f.dn': 'Debit note bán ra', 'bod.f.jdn': 'Job đã báo nợ', 'bod.f.pt': 'Phiếu thu', 'bod.f.pi': 'HĐ mua vào', 'bod.f.pc': 'Phiếu chi đối tác', 'bod.f.odn': 'Đề nghị chi Ops',
  'bod.dock': 'Cột phải', 'bod.dockClose': 'Đóng cột phải',
  'bod.dock.wait': 'Chờ duyệt', 'bod.dock.note': 'Ghi chú dữ liệu',
  'bod.ph.back': 'Về mục Thêm', 'bod.ph.dark': 'Chuyển giao diện tối', 'bod.ph.jobs': 'Job trong kỳ', 'bod.ph.cus': 'Khách có job', 'bod.ph.cusSub': 'khách khác nhau', 'bod.ph.avgMonth': 'TB / tháng', 'bod.ph.trf': 'Chuyến TRF', 'bod.ph.svc': 'Dòng dịch vụ con',
  'bod.ph.chart': 'Job theo tháng', 'bod.ph.12m': '12 tháng', 'bod.ph.wait': 'Chờ BOD duyệt', 'bod.ph.evs': 'Sai sót & khen thưởng', 'bod.ph.waitN': '{n} chờ BOD duyệt',
  'bod.ph.e1': 'Sai sót L2 · ThuyNTT · SE261040115', 'bod.ph.e2': 'Sai sót L3 · ANHLT, KietLT · SE261040322', 'bod.ph.e3': 'Khen thưởng · ThuongLVH · SE261040201', 'bod.ph.e4': 'Sai sót L2 · TUANNT, HOATTN · SE261040455',
  'bod.ph.sConfirmed': 'Chờ BOD duyệt', 'bod.ph.sPending': 'Chờ TP xác nhận', 'bod.ph.sExplain': 'Chờ giải trình',
  'bod.ph.open': 'Job chưa hoàn tất', 'bod.ph.open120': '· 120 ngày', 'bod.ph.kpi': 'KPI kỳ Oct/2026', 'bod.ph.kpiSub': 'Đang mở · chốt kỳ ở bản desktop',
  'bod.attn': 'Mốc cảnh báo',
  'bod.sla.c.user': 'Người',
  'bod.sla.c.seat': 'Ghế',
  'bod.sla.c.box': 'Hộp chính',
  'bod.sla.c.n': 'Mail xử lý',
  'bod.sla.c.ok': 'Đúng SLA',
  'bod.sla.c.resp': 'Trả lời TB',
  'bod.sla.c.over': 'Quá SLA hôm nay',
  'bod.sla.c.chat': 'Chat chờ > 30′',
  'bod.sla.k.ok': 'Mail đúng SLA',
  'bod.sla.k.okSub': 'SLA 30 phút làm việc',
  'bod.sla.k.resp': 'Trả lời trung bình',
  'bod.sla.k.respSub': 'nhanh hơn kỳ trước 3′',
  'bod.sla.k.over': 'Mail quá SLA',
  'bod.sla.k.today': 'hôm nay',
  'bod.sla.k.chat': 'Chat khách chờ > 30′',
  'bod.sla.k.zalo': 'Zalo OA đánh giá',
  'bod.sla.k.claim': 'Ca khiếu nại mở',
  'bod.sla.ch1': 'Mail đúng SLA 12 tháng',
  'bod.sla.ch1s': '% mail trả lời trong 30 phút làm việc · nguồn HANA Box',
  'bod.sla.ch1l': 'Đúng SLA',
  'bod.sla.ch1m': 'Mốc 90%',
  'bod.sla.box': 'Trả lời TB theo hộp mail',
  'bod.sla.boxs': 'phút làm việc · kỳ này',
  'bod.sla.ch2': 'Trả lời trung bình 12 tháng',
  'bod.sla.ch2s': 'phút làm việc · mục tiêu 20′',
  'bod.sla.ch2l': 'Phút',
  'bod.sla.ch2m': 'Mục tiêu 20′',
  'bod.sla.attnS': 'bấm để mở hộp mail / cuộc chat',
  'bod.sla.a1': 'Mail quá SLA hôm nay',
  'bod.sla.a2': 'support@ dưới mốc 90%',
  'bod.sla.a2s': '3 tháng liền 86–90%',
  'bod.sla.a3': 'Chat khách chờ > 30′',
  'bod.sla.a4': 'Ca khiếu nại đang mở',
  'bod.sla.a4s': 'quá 3 ngày làm việc: 1',
  'bod.sla.a5': 'Đánh giá Zalo OA dưới 4 sao',
  'bod.sla.a5s': 'tuần này',
  'bod.sla.rank': 'Xếp hạng người',
  'bod.sla.ranks': 'kỳ này · xếp theo % đúng SLA · nhắc qua Hei',
  'bod.sla.byBox': 'Theo hộp mail',
  'bod.sla.byBoxs': 'nguồn HANA Box',
  'bod.sla.byUser': 'Theo người',
  'bod.sla.byUsers': 'top chậm nhất · nhắc qua Hei',
  'bod.fl.c.plate': 'Biển số',
  'bod.fl.c.drv': 'Tài xế',
  'bod.fl.c.trips': 'Chuyến',
  'bod.fl.c.ontime': 'Đúng giờ',
  'bod.fl.c.fuel': 'Nhiên liệu L/100 km',
  'bod.fl.c.inc': 'Sự cố',
  'bod.fl.c.insp': 'Hạn đăng kiểm',
  'bod.fl.k.act': 'Xe hoạt động',
  'bod.fl.k.trips': 'Chuyến trong kỳ',
  'bod.fl.k.ontime': 'Xe đúng giờ',
  'bod.fl.k.ontimeSub': 'mốc cảnh báo 92%',
  'bod.fl.k.km': 'Km chạy',
  'bod.fl.k.insp': 'Sắp hạn đăng kiểm',
  'bod.fl.k.inc': 'Sự cố',
  'bod.fl.ch1': 'Chuyến xe nhà 12 tháng',
  'bod.fl.ch1s': 'chuyến hoàn tất · nguồn HANA Mov · GPS',
  'bod.fl.ch1l': 'Chuyến',
  'bod.fl.drv': 'Tài xế · chuyến trong kỳ',
  'bod.fl.drvs': 'top 5 · mở hồ sơ',
  'bod.fl.ch2': 'Đúng giờ 12 tháng',
  'bod.fl.ch2s': '% chuyến tới điểm đúng hẹn · GPS',
  'bod.fl.ch2l': 'Đúng giờ',
  'bod.fl.ch2m': 'Mốc cảnh báo 92%',
  'bod.fl.attnS': 'giấy tờ xe · trễ chuyến · nhiên liệu',
  'bod.fl.a1': '50E-139.70 hạn đăng kiểm',
  'bod.fl.a1s': 'còn 9 ngày làm việc · cần xe thay',
  'bod.fl.a2': '51D-118.29 hết hạn bảo hiểm',
  'bod.fl.a2s': 'gia hạn trước 15 ngày',
  'bod.fl.a3': 'Chuyến trễ > 1 giờ trong kỳ',
  'bod.fl.a3s': '4 chuyến thuộc 50E-139.70',
  'bod.fl.a4': 'Nhiên liệu / 100 km tăng',
  'bod.fl.a4s': '50E-139.70 35,1 L · TB đội 32,7 L',
  'bod.fl.a5': 'Bảo dưỡng quá km',
  'bod.fl.a5s': '51D-562.03 vượt 1.200 km',
  'bod.fl.rank': 'Xếp hạng xe',
  'bod.fl.ranks': 'kỳ này · xếp theo số chuyến',
  'bod.fl.byVeh': 'Theo xe',
  'bod.fl.byVehs': 'nguồn HANA Mov · GPS',
  'bod.fl.v1': '36 chuyến · 98% đúng giờ',
  'bod.fl.v2': '33 chuyến · 91%',
  'bod.fl.v3': '31 chuyến · 88%',
  'bod.fl.know': 'Việc cần BOD biết',
  'bod.fl.n1': 'Xe 50E-139.70 hạn đăng kiểm 05/Nov',
  'bod.fl.n3': 'Nhiên liệu / km tăng',
  'bod.evt.t.open': 'Đang mở', 'bod.evt.t.opens': 'Nháp → Chờ BOD duyệt', 'bod.evt.t.explain': 'Chờ giải trình', 'bod.evt.t.pending': 'Chờ TP xác nhận', 'bod.evt.t.bod': 'Chờ BOD duyệt', 'bod.evt.t.ok': 'Hiệu lực', 'bod.evt.t.oks': 'mới tính vào điểm KPI',
  'bod.evt.st.Draft': 'Nháp', 'bod.evt.st.Explain': 'Chờ giải trình', 'bod.evt.st.Pending': 'Chờ TP xác nhận', 'bod.evt.st.Confirmed': 'Chờ BOD duyệt', 'bod.evt.st.Approved': 'Hiệu lực', 'bod.evt.st.Rejected': 'Bác', 'bod.evt.st.Cancelled': 'Huỷ',
  'bod.evt.flow': 'Luồng xử lý', 'bod.evt.flowS': 'số vụ theo trạng thái · {n} vụ', 'bod.evt.cat': 'Theo danh mục', 'bod.evt.catS': 'Penalty / Reward · số vụ',
  'bod.evt.book': 'Sổ sai sót & khen thưởng', 'bod.evt.none': 'Không có vụ nào khớp bộ lọc',
  'bod.evt.f.st': 'Trạng thái', 'bod.evt.f.open': 'Đang mở', 'bod.evt.f.done': 'Hiệu lực', 'bod.evt.f.closed': 'Bác / Huỷ', 'bod.evt.f.all': 'Tất cả', 'bod.evt.f.typ': 'Loại', 'bod.evt.f.P': 'Sai sót', 'bod.evt.f.R': 'Khen thưởng',
  'bod.evt.c.code': 'Mã', 'bod.evt.c.typ': 'Loại', 'bod.evt.c.cat': 'Danh mục', 'bod.evt.c.ref': 'Job / dịch vụ', 'bod.evt.c.ppl': 'Người liên quan', 'bod.evt.c.st': 'Trạng thái', 'bod.evt.c.next': 'Bước tiếp', 'bod.evt.pen': 'Sai sót {sev}', 'bod.evt.rew': 'Khen thưởng',
  'bod.evt.n.Draft': 'Người ghi nhận gửi đi', 'bod.evt.n.Explain': '{who} giải trình', 'bod.evt.n.Pending': '{mgr} xác nhận', 'bod.evt.n.Confirmed': '[BOD-DIR] PHILIP duyệt',
  'bod.evt.cat.P_AMEND': 'Sai chứng từ → phí amend/manifest', 'bod.evt.cat.P_SILATE': 'Trễ SI/VGM → phí trễ/rớt tàu', 'bod.evt.cat.P_DEMDET': 'Trễ lấy/trả cont → DEM/DET/lưu bãi', 'bod.evt.cat.P_TRUCK': 'Điều xe sai → phí chờ/neo xe', 'bod.evt.cat.P_INVOICE': 'Sai hoá đơn / thanh toán nhầm', 'bod.evt.cat.P_LOSTDOC': 'Mất / hư hỏng chứng từ', 'bod.evt.cat.P_NOTIFY': 'Quên thông báo khách', 'bod.evt.cat.P_CLAIM': 'Khách khiếu nại có căn cứ', 'bod.evt.cat.P_PROCESS': 'Vi phạm quy trình', 'bod.evt.cat.R_PRAISE': 'Khách khen bằng văn bản', 'bod.evt.cat.R_RECOVER': 'Thu hồi được phí phát sinh', 'bod.evt.cat.R_SAVE': 'Tiết kiệm chi phí',
  'bod.evt.new': 'Ghi nhận',
});

addMessages('en', {
  'bod.svc.c.type': 'Job type',
  'bod.svc.c.cus': 'Customer',
  'bod.svc.c.pod': 'Port of discharge',
  'bod.svc.c.sub': 'Sub-service',
  'bod.svc.c.portName': 'Port name',
  'bod.svc.c.jobs': 'Jobs',
  'bod.svc.c.lines': 'Service lines',
  'bod.svc.c.share': 'Share',
  'bod.svc.c.open': 'Open',
  'bod.svc.bar.cus': 'Customers ranked by jobs',
  'bod.svc.bars.cus': 'top 12 · 90 days',
  'bod.svc.bar.pod': 'Routes ranked by jobs',
  'bod.svc.bars.pod': 'destination port · 90 days',
  'bod.svc.bar.sub': 'Sub-service lines in period',
  'bod.svc.bars.sub': 'service lines',
  'bod.svc.openN': '{n} open',
  'bod.svc.t.jobs': 'Jobs in period',
  'bod.svc.t.ob': 'OB share',
  'bod.svc.t.rf': 'Reefer RF',
  'bod.svc.t.svcj': 'Jobs with extra services',
  'bod.svc.t.jobN': '{n} jobs',
  'bod.svc.group': 'Group by',
  'bod.svc.g.time': 'Time',
  'bod.svct.k1': 'Jobs by type · 12 months',
  'bod.svct.s1': 'bars OB · LS · TR · line = TRF transport lines',
  'bod.svct.trf': 'TRF transport',
  'bod.svct.peak': 'peak {n} jobs',
  'bod.svct.k2': 'Work by service · 12 months',
  'bod.svct.s2': 'Jobs by type (OB · LS · TR) and sub-service lines (TRF transport · DOC documents · CCF customs · SCY yard · DDL document delivery) by month',
  'bod.svct.month': 'Month',
  'bod.svct.k3': 'Sub-service × month matrix',
  'bod.svct.s3': 'service lines · dark cell = peak month of that service · last column = latest quarter vs previous',
  'bod.svct.total': 'Total',
  'bod.svct.sum': 'Total',
  'bod.svct.quarter': 'Qtr',
  'bod.svct.ins2': 'sub-service matrix',
  'bod.svct.i1': 'Peak {hi} ({hn} jobs), low {lo} ({ln} jobs — Tet).',
  'bod.svct.i2': 'Last 3 months average {r} jobs/month, {c} vs the previous 3 months',
  'bod.svct.i2b': ' — recovering from the T9 low.',
  'bod.svct.i3': 'TRF (transport) {a} last quarter, DOC (documents) {b} — documents fell faster than jobs; check whether DOC service entries are missing.',
  'bod.svct.j1up': '{c} ({n}) grew most last quarter: {d}.',
  'bod.svct.j1dn': '{c} ({n}) fell least — every service fell last quarter: {d}.',
  'bod.svct.j2': '{c} ({n}) fell most: {d} — check for missing service lines or lost customers.',
  'bod.svct.j3': 'A month that is pale across the column (T2) is the shared low season; a dark cell off-season is an anomaly to ask the owner about.',
  'bod.svc.g.type': 'Job type',
  'bod.svc.g.cus': 'Customer',
  'bod.svc.g.pod': 'Lane',
  'bod.svc.g.sub': 'Sub-service',
  'bod.svc.k.type': 'By job type',
  'bod.svc.ins': 'Insights',
  'bod.svc.ins.sub': 'by job mix',
  'bod.svc.k.cus': 'By customer · top 12',
  'bod.svc.k.pod': 'By lane · port of discharge',
  'bod.svc.k.sub': 'By sub-service',
  'bod.svc.s.type': 'jobs in period',
  'bod.svc.s.cus': 'last 90 days (1,346 jobs) · independent of the selected period',
  'bod.svc.s.pod': 'last 90 days · POL: VNSGN 1,076 · VNVUT 389 · VNHPH 89 · VNDNA 12',
  'bod.svc.s.sub': 'service lines in period',
  'bod.dk.w1': 'Awaiting BOD approval',
  'bod.dk.w1s': '1 case · [BOD-DIR] PHILIP',
  'bod.dk.w1i': 'KPE-2610-001 · Document error → amend/manifest fee',
  'bod.dk.w2': 'Controls',
  'bod.dk.w2s': 'self-approved / concurrent roles',
  'bod.dk.w2i': 'Self-approval & concurrent-role report',
  'bod.dk.w2is': 'on BOD desk · Overview',
  'bod.dk.w2l': 'Open BOD desk ›',
  'bod.dk.w3s': 'score by position · period close',
  'bod.dk.w3i': 'Period Oct/2026 is open',
  'bod.dk.w3is': 'not closed',
  'bod.dk.w3l': 'Open KPI ›',
  'bod.dk.n0': 'Data notes',
  'bod.dk.n0s': 'read before comparing periods',
  'bod.dk.n1': 'October up to 22/Oct/2026',
  'bod.dk.n1s': 'jobs with a future JobDate are still counted',
  'bod.dk.n2': 'Customers / carriers are distinct counts',
  'bod.dk.n2s': 'monthly · quarter / year show monthly average',
  'bod.dk.n3': 'Top customers, lanes: 90 days',
  'bod.dk.n3s': 'does not change with the selected period',
  'bod.dk.n4': 'Sub-services: row count',
  'bod.dk.n4s': 'one job can have several service rows',
  'bod.later': 'Not available in this version',
  'bod.title': 'Executive report', 'bod.backLabel': 'Back to Overview',
  'bod.mode.m': 'Month', 'bod.mode.q': 'Quarter', 'bod.mode.y': 'Year',
  'bod.modeLabel': 'Period type', 'bod.prev': 'Previous period', 'bod.next': 'Next period', 'bod.density': 'Display density',
  'bod.dense.std': 'Standard', 'bod.dense.cmp': 'Compact',
  'bod.notif': 'Notifications', 'bod.openRight': 'Open right panel', 'bod.export': 'Export monthly report',
  'bod.reports': 'Reports', 'bod.tab.ov': 'Overview', 'bod.tab.hr': 'People', 'bod.tab.ops': 'Business activity', 'bod.tab.svc': 'Service performance', 'bod.tab.sla': 'Mail & chat SLA', 'bod.tab.fleet': 'Fleet', 'bod.tab.evt': 'Errors & rewards',
  'bod.vsPrev': ' vs previous period', 'bod.prevNone': 'previous: —', 'bod.prevNone2': 'previous —', 'bod.prevVal': '{d} · prev {v}',
  'bod.spark': '{k} 12 months {a}–{b}',
  'bod.avgSuffix': ' · avg/month',
  'bod.sec.metrics': 'Metrics',
  'bod.t.jobs': 'Jobs in period', 'bod.t.ob': 'OB · export', 'bod.t.ls': 'LS · logistics', 'bod.t.tr': 'TR · transport', 'bod.t.rf': 'Reefer RF',
  'bod.t.rfSub': '{p} of total jobs', 'bod.t.cus': 'Customers with jobs', 'bod.t.cusSub': 'distinct customers', 'bod.t.car': 'Carriers', 'bod.t.carSub': 'distinct carriers', 'bod.t.trf': 'TRF trips',
  'bod.chart': 'Jobs by month', 'bod.chartSub': 'by JobDate', 'bod.peak': 'peak 560 jobs',
  'bod.chartAria': 'Jobs by month, split OB / LS / TR / IB: {v}',
  'bod.open': 'Unfinished jobs', 'bod.openSub': 'last 120 days',
  'bod.openAria': 'Unfinished jobs by group: {v}', 'bod.openAria2': 'Unfinished jobs by ShipmentStatus',
  'bod.notFinish': 'not Finish yet',
  'bod.etd14': 'ETD in next 14 days', 'bod.cus90': 'Customers active in 90 days',
  'bod.sub': 'Sub-services', 'bod.subSub': 'rows by JobDate', 'bod.thisP': 'This period', 'bod.prevP': 'Previous period',
  'bod.subAria': 'Sub-services: {v}', 'bod.opening': '{src} · {n} open',
  'bod.s.trf': 'TRF · Transport (trips)', 'bod.s.doc': 'DOC · Documents (C/O, quarantine, fumigation)', 'bod.s.ccf': 'CCF · Customs clearance', 'bod.s.scy': 'SCY · Yard / CY', 'bod.s.ddl': 'DDL · Document delivery', 'bod.s.svcj': 'Jobs with extra services',
  'bod.fin': 'Financial documents', 'bod.finSub': 'documents in period · no amounts',
  'bod.f.dn': 'Debit notes issued', 'bod.f.jdn': 'Jobs billed', 'bod.f.pt': 'Receipts', 'bod.f.pi': 'Purchase invoices', 'bod.f.pc': 'Partner payment vouchers', 'bod.f.odn': 'Ops payment requests',
  'bod.dock': 'Right panel', 'bod.dockClose': 'Close right panel',
  'bod.dock.wait': 'Pending approval', 'bod.dock.note': 'Data notes',
  'bod.ph.back': 'Back to More', 'bod.ph.dark': 'Switch to dark theme', 'bod.ph.jobs': 'Jobs in period', 'bod.ph.cus': 'Customers with jobs', 'bod.ph.cusSub': 'distinct customers', 'bod.ph.avgMonth': 'avg / month', 'bod.ph.trf': 'TRF trips', 'bod.ph.svc': 'Sub-service lines',
  'bod.ph.chart': 'Jobs by month', 'bod.ph.12m': '12 months', 'bod.ph.wait': 'Awaiting BOD approval', 'bod.ph.evs': 'Errors & commendations', 'bod.ph.waitN': '{n} awaiting BOD approval',
  'bod.ph.e1': 'Error L2 · ThuyNTT · SE261040115', 'bod.ph.e2': 'Error L3 · ANHLT, KietLT · SE261040322', 'bod.ph.e3': 'Commendation · ThuongLVH · SE261040201', 'bod.ph.e4': 'Error L2 · TUANNT, HOATTN · SE261040455',
  'bod.ph.sConfirmed': 'Awaiting BOD', 'bod.ph.sPending': 'Awaiting head', 'bod.ph.sExplain': 'Awaiting explanation',
  'bod.ph.open': 'Unfinished jobs', 'bod.ph.open120': '· 120 days', 'bod.ph.kpi': 'KPI period Oct/2026', 'bod.ph.kpiSub': 'Open · close the period on desktop',
  'bod.attn': 'Alerts',
  'bod.sla.c.user': 'Person',
  'bod.sla.c.seat': 'Seat',
  'bod.sla.c.box': 'Main inbox',
  'bod.sla.c.n': 'Mails handled',
  'bod.sla.c.ok': 'On SLA',
  'bod.sla.c.resp': 'Avg reply',
  'bod.sla.c.over': 'Over SLA today',
  'bod.sla.c.chat': 'Chat waiting > 30′',
  'bod.sla.k.ok': 'Mail on SLA',
  'bod.sla.k.okSub': '30 working-minute SLA',
  'bod.sla.k.resp': 'Average reply',
  'bod.sla.k.respSub': '3′ faster than last period',
  'bod.sla.k.over': 'Mail over SLA',
  'bod.sla.k.today': 'today',
  'bod.sla.k.chat': 'Chats waiting > 30′',
  'bod.sla.k.zalo': 'Zalo OA rating',
  'bod.sla.k.claim': 'Open complaints',
  'bod.sla.ch1': 'Mail on SLA, 12 months',
  'bod.sla.ch1s': '% replied within 30 working minutes · from HANA Box',
  'bod.sla.ch1l': 'On SLA',
  'bod.sla.ch1m': '90% line',
  'bod.sla.box': 'Avg reply by inbox',
  'bod.sla.boxs': 'working minutes · this period',
  'bod.sla.ch2': 'Average reply, 12 months',
  'bod.sla.ch2s': 'working minutes · target 20′',
  'bod.sla.ch2l': 'Minutes',
  'bod.sla.ch2m': 'Target 20′',
  'bod.sla.attnS': 'tap to open the inbox / chat',
  'bod.sla.a1': 'Mail over SLA today',
  'bod.sla.a2': 'support@ under 90%',
  'bod.sla.a2s': '3 months at 86–90%',
  'bod.sla.a3': 'Chats waiting > 30′',
  'bod.sla.a4': 'Open complaints',
  'bod.sla.a4s': 'over 3 working days: 1',
  'bod.sla.a5': 'Zalo OA rating under 4 stars',
  'bod.sla.a5s': 'this week',
  'bod.sla.rank': 'People ranking',
  'bod.sla.ranks': 'this period · by % on SLA · nudge via Hei',
  'bod.sla.byBox': 'By inbox',
  'bod.sla.byBoxs': 'from HANA Box',
  'bod.sla.byUser': 'By person',
  'bod.sla.byUsers': 'slowest first · nudge via Hei',
  'bod.fl.c.plate': 'Plate',
  'bod.fl.c.drv': 'Driver',
  'bod.fl.c.trips': 'Trips',
  'bod.fl.c.ontime': 'On time',
  'bod.fl.c.fuel': 'Fuel L/100 km',
  'bod.fl.c.inc': 'Incidents',
  'bod.fl.c.insp': 'Inspection due',
  'bod.fl.k.act': 'Vehicles active',
  'bod.fl.k.trips': 'Trips in period',
  'bod.fl.k.ontime': 'On-time vehicles',
  'bod.fl.k.ontimeSub': 'alert line 92%',
  'bod.fl.k.km': 'Km driven',
  'bod.fl.k.insp': 'Inspection due soon',
  'bod.fl.k.inc': 'Incidents',
  'bod.fl.ch1': 'Own-fleet trips, 12 months',
  'bod.fl.ch1s': 'completed trips · from HANA Mov · GPS',
  'bod.fl.ch1l': 'Trips',
  'bod.fl.drv': 'Drivers · trips in period',
  'bod.fl.drvs': 'top 5 · open profile',
  'bod.fl.ch2': 'On time, 12 months',
  'bod.fl.ch2s': '% of trips on time at stop · GPS',
  'bod.fl.ch2l': 'On time',
  'bod.fl.ch2m': 'Alert line 92%',
  'bod.fl.attnS': 'vehicle papers · late trips · fuel',
  'bod.fl.a1': '50E-139.70 inspection due',
  'bod.fl.a1s': '9 working days left · need a replacement',
  'bod.fl.a2': '51D-118.29 insurance expires',
  'bod.fl.a2s': 'renew 15 days ahead',
  'bod.fl.a3': 'Trips late > 1 hour in period',
  'bod.fl.a3s': '4 trips on 50E-139.70',
  'bod.fl.a4': 'Fuel / 100 km up',
  'bod.fl.a4s': '50E-139.70 35.1 L · fleet avg 32.7 L',
  'bod.fl.a5': 'Service overdue by km',
  'bod.fl.a5s': '51D-562.03 over by 1,200 km',
  'bod.fl.rank': 'Vehicle ranking',
  'bod.fl.ranks': 'this period · by trips',
  'bod.fl.byVeh': 'By vehicle',
  'bod.fl.byVehs': 'from HANA Mov · GPS',
  'bod.fl.v1': '36 trips · 98% on time',
  'bod.fl.v2': '33 trips · 91%',
  'bod.fl.v3': '31 trips · 88%',
  'bod.fl.know': 'For the BOD to know',
  'bod.fl.n1': 'Vehicle 50E-139.70 inspection due 05/Nov',
  'bod.fl.n3': 'Fuel / km up',
  'bod.evt.t.open': 'Open', 'bod.evt.t.opens': 'Draft → awaiting BOD', 'bod.evt.t.explain': 'Awaiting explanation', 'bod.evt.t.pending': 'Awaiting manager', 'bod.evt.t.bod': 'Awaiting BOD', 'bod.evt.t.ok': 'In effect', 'bod.evt.t.oks': 'counts toward KPI score',
  'bod.evt.st.Draft': 'Draft', 'bod.evt.st.Explain': 'Awaiting explanation', 'bod.evt.st.Pending': 'Awaiting manager', 'bod.evt.st.Confirmed': 'Awaiting BOD', 'bod.evt.st.Approved': 'In effect', 'bod.evt.st.Rejected': 'Rejected', 'bod.evt.st.Cancelled': 'Cancelled',
  'bod.evt.flow': 'Workflow', 'bod.evt.flowS': 'cases by status · {n} cases', 'bod.evt.cat': 'By category', 'bod.evt.catS': 'Penalty / Reward · cases',
  'bod.evt.book': 'Errors & rewards ledger', 'bod.evt.none': 'No case matches the filter',
  'bod.evt.f.st': 'Status', 'bod.evt.f.open': 'Open', 'bod.evt.f.done': 'In effect', 'bod.evt.f.closed': 'Rejected / Cancelled', 'bod.evt.f.all': 'All', 'bod.evt.f.typ': 'Type', 'bod.evt.f.P': 'Errors', 'bod.evt.f.R': 'Rewards',
  'bod.evt.c.code': 'Code', 'bod.evt.c.typ': 'Type', 'bod.evt.c.cat': 'Category', 'bod.evt.c.ref': 'Job / service', 'bod.evt.c.ppl': 'People involved', 'bod.evt.c.st': 'Status', 'bod.evt.c.next': 'Next step', 'bod.evt.pen': 'Error {sev}', 'bod.evt.rew': 'Reward',
  'bod.evt.n.Draft': 'Reporter submits', 'bod.evt.n.Explain': '{who} to explain', 'bod.evt.n.Pending': '{mgr} to confirm', 'bod.evt.n.Confirmed': '[BOD-DIR] PHILIP to approve',
  'bod.evt.cat.P_AMEND': 'Wrong documents → amend/manifest fee', 'bod.evt.cat.P_SILATE': 'Late SI/VGM → late/rollover fee', 'bod.evt.cat.P_DEMDET': 'Late pickup/return → DEM/DET/storage', 'bod.evt.cat.P_TRUCK': 'Wrong dispatch → waiting fee', 'bod.evt.cat.P_INVOICE': 'Wrong invoice / payment', 'bod.evt.cat.P_LOSTDOC': 'Lost / damaged documents', 'bod.evt.cat.P_NOTIFY': 'Forgot to notify customer', 'bod.evt.cat.P_CLAIM': 'Valid customer claim', 'bod.evt.cat.P_PROCESS': 'Process violation', 'bod.evt.cat.R_PRAISE': 'Written customer praise', 'bod.evt.cat.R_RECOVER': 'Recovered extra fees', 'bod.evt.cat.R_SAVE': 'Cost saving',
  'bod.evt.new': 'New case',
});
